import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VersionService {

  private versionUrl = environment.versionUrl;

  private get authHeaders() {
    const raw = sessionStorage.getItem('authToken');
    const token = raw ? JSON.parse(raw)?.token : null;
    return {
      headers: new HttpHeaders({
        ...(token ? { 'Authorization': 'Bearer ' + token } : {}),
      })
    };
  }

  constructor(private http: HttpClient) { }

  getVersion(): Observable<string> {
    return this.http.get(this.versionUrl, { ...this.authHeaders, responseType: 'text' }).pipe(
      map(response => {
        try {
          const parsed = JSON.parse(response);
          return parsed?.version ?? response;
        } catch {
          return response;
        }
      }),
      catchError(error => {
        console.error('Error fetching version:', error);
        return of('');
      })
    );
  }

}
